<script setup>
import mailchimpQuery from '~/assets/gql/mailchimp.gql'

const { locale, t } = useI18n()
const localePath = useLocalePath()

const { result: queryData } = useQuery(mailchimpQuery, {
  language: locale.value.toUpperCase(),
})

const data = computed(() => queryData.value?.articles?.nodes[0])
</script>

<template>
  <div class="navigationBottom">
    <div
      v-if="data?.GlobalAttributes?.mailchimp?.mailchimpUrl"
      id="mc_embed_signup"
    >
      <form
        id="mc-embedded-subscribe-form"
        :action="data.GlobalAttributes.mailchimp.mailchimpUrl"
        method="post"
        name="mc-embedded-subscribe-form"
        class="validate"
        target="_blank"
      >
        <div id="mc_embed_signup_scroll">
          <div class="mc-field-group">
            <label for="mce-EMAIL" class="email">
              <input
                id="mce-EMAIL"
                type="email"
                value=""
                name="EMAIL"
                class="email__input text_minor_2"
                :placeholder="t('general.newsleeter')"
              />
              <label for="mc-embedded-subscribe" class="email__submit">
                <input
                  id="mc-embedded-subscribe"
                  type="submit"
                  value=""
                  name="subscribe"
                />
                <i class="arrow left"></i>
              </label>
            </label>
          </div>
          <div id="mce-responses" class="clear foot">
            <div
              id="mce-error-response"
              class="response"
              style="display: none"
            ></div>
            <div
              id="mce-success-response"
              class="response"
              style="display: none"
            ></div>
          </div>
          <!-- Bot protection -->
          <div style="position: absolute; left: -5000px" aria-hidden="true">
            <input
              type="text"
              name="b_206a0978d9b93d549d314fe0e_79417802be"
              tabindex="-1"
              value=""
            />
          </div>
        </div>
      </form>
    </div>
    <NuxtLink
      class="button button__boring text_minor_2"
      :to="localePath('search')"
    >
      <p>{{ t('general.search') }}</p>
      <i class="arrow left"></i>
    </NuxtLink>
  </div>
</template>

<style lang="scss" scoped>
.navigationBottom {
  flex-basis: 380px;
}

.arrow {
  border: solid $color-3;
  border-width: 0 1px 1px 0;
  display: inline-block;
  padding: 5px;
}

.left {
  transform: rotate(-45deg);
  -webkit-transform: rotate(-45deg);
}

.email {
  inline-size: 100%;
  display: block;
  position: relative;

  ::placeholder {
    color: $color-4;
    opacity: 1;
  }

  :-ms-input-placeholder {
    color: $color-4;
  }

  ::-ms-input-placeholder {
    color: $color-4;
  }

  &:hover {
    ::placeholder {
      color: $color-2;
      opacity: 1;
    }

    :-ms-input-placeholder {
      color: $color-2;
    }

    ::-ms-input-placeholder {
      color: $color-2;
    }

    .email__input {
      border: 1px solid $color-2;
    }
    .arrow {
      border-color: $color-2;
    }
  }

  &__input {
    outline: none;
    &:focus-visible {
      outline: 1px solid $color-2;
    }

    background-color: $color-1;
    transition: background-color 0.3s;
    text-decoration: none;
    color: $color-2;
    border-radius: 7px;
    border: 1px solid $color-4;
    inline-size: 100%;
    block-size: 48px;
    padding: 1em;
    padding-inline-end: 40px;
    display: block;
  }

  &__submit {
    position: absolute;
    top: 50%;
    right: 0px;
    transform: translateY(-50%);
    padding: 0 14px;
    cursor: pointer;

    .arrow {
      position: absolute;
      top: 50%;
      right: 14px;
      transform: translate(0, -50%) rotate(-45deg) !important;
    }
  }
}
</style>
